import { IReadOptions } from '@samc/common';
import { CachedDataSource } from '@/Sources/BaseDataSources';
import { ITaskTypeModel } from '@samc/taskmanagement-ui';
import { AjaxHelper } from '@samc/common';
import { IResponse } from '@samc/taskmanagement-ui/dist/types/interfaces';

export class TaskTypesSource extends CachedDataSource<ITaskTypeModel> {

  private readonly _helper: AjaxHelper;
  /**
   * Constructor meant to build out the source
   * 
   * @param _apiRoot The current api root needed for this data source
   * @param _jwt The jwt used for this data source
   * @param _token The token used for this data source
   */
  public constructor(private _apiRoot?: string, private _jwt: string | null = null, private _token: string | null = null) {
    super();
    this._helper = new AjaxHelper(_apiRoot ?? '', _token ?? null, null, _jwt ?? null);
  }

  public async loadData(options: IReadOptions, abortController: AbortController): Promise<ITaskTypeModel[]> {
    let data: ITaskTypeModel[] = (await this._helper.getData<IResponse<ITaskTypeModel[]>>('/tasktype')).data;

    // Filter to only include task types with taskLevelId === 2 (Transaction)
    return data.filter(tt => tt.taskLevelId === 2).sort((a, b) => a.name.localeCompare(b.name));
  }
}
